export const data = [
  {
    id: "1",
    title: "What are accordion components?",
    text: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Facilis quidem, nisi est eos nobis quaerat dignissimos quos ipsum voluptate soluta tenetur, impedit ipsam voluptatibus aliquam quis repellendus deserunt corporis sequi.",
  },
  {
    id: "2",
    title: "What are they used for?",
    text: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Facilis quidem, nisi est eos nobis quaerat dignissimos quos ipsum voluptate soluta tenetur, impedit ipsam voluptatibus aliquam quis repellendus deserunt corporis sequi.",
  },
  {
    id: "3",
    title: "Accordion as a musical instrument",
    text: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Facilis quidem, nisi est eos nobis quaerat dignissimos quos ipsum voluptate soluta tenetur, impedit ipsam voluptatibus aliquam quis repellendus deserunt corporis sequi.",
  },
  {
    id: "4",
    title: "Can I create an accordion component with with a diffrent framework?",
    text: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Facilis quidem, nisi est eos nobis quaerat dignissimos quos ipsum voluptate soluta tenetur, impedit ipsam voluptatibus aliquam quis repellendus deserunt corporis sequi.",
  },
  {
    id: "5",
    title: "Some text",
    text: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Facilis quidem, nisi est eos nobis quaerat dignissimos quos ipsum voluptate soluta tenetur, impedit ipsam voluptatibus aliquam quis repellendus deserunt corporis sequi.",
  },
];
